import React from "react";
import { Edit as RaEdit, useNotify } from "react-admin";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import Form from "./Form";
import Toolbar from "./Toolbar";

const transformJson = (str) => {
	try {
		const transformed = JSON.stringify(JSON.parse(str), null, 4);
		return transformed;
	} catch (error) {
		return str;
	}
};

const Edit = (props) => {
	const classes = useFormStyles();
	const notify = useNotify();
	const onSuccess = (data) => {
		notify("ra.notification.updated", "info", { smart_count: 1 });
	};
	return (
		<RaEdit
			{...props}
			classes={classes}
			mutationMode="pessimistic"
			onSuccess={onSuccess}
			title={<Title source="name" />}
			transform={(data) => ({
				...data,
				sync_config: transformJson(data?.sync_config || "{}"),
				sync_config_customers: transformJson(
					data?.sync_config_customers || "{}"
				),
				sync_channel_config: transformJson(data?.sync_channel_config || "{}"),
			})}
		>
			<Form toolbar={<Toolbar />} />
		</RaEdit>
	);
};
export default Edit;
